import dayjs from 'dayjs';
import i18n from '@/i18n';

export default{
  setTags(item, tagTypeList) {
    const resultTags = [];
    const tagSet = new Set(tagTypeList);
    if (tagSet.has('updated')) {
      const text = this.setUpdateText(item);
      if (text) resultTags.push({color:'yellow', text});
    }
    if (tagSet.has('status')) {
      const status = item.status;
      const statusList = {
        2: {
          color:'yellow',
          text: '修訂中',
        },
        released: {
          color:'green',
          text: '已發布',
        },
        draft: {
          color:'blue',
          text: '草稿',
        }
      }
      const chip = statusList[status];
      if (chip) resultTags.push(chip);
    }
    return resultTags;
  },
  setUpdateText(item) {
    if (!item.last_version.updated_at) return '';
    const updatedAt = dayjs(item.last_version.updated_at);
    const today = dayjs(new Date());
    const dateDifference = today.diff(updatedAt, 'days');
    const text = dateDifference <= 30
      ? i18n.t('近{number}個月更新', {number: 1})
      : dateDifference > 30 && dateDifference <= 90
      ? i18n.t('近{number}個月更新', {number: 3})
      : dateDifference > 90 && dateDifference <= 180
      ? i18n.t('近{number}個月更新', {number: 6})
      : '';
    return text;
  }
}
